import React from "react";
import styled from "styled-components";
import { FC } from "react";
import { theme } from "../config/theme";
import { Icon } from "../components/icon";
import { IconId } from "../components/icon";

interface SelectProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  value?: string;
  iconId?: IconId;
  children?: any;
  onChange?: (e: any) => void;
}

const SelectGroup = styled.div`
  position: relative;
  width: 100%;
`;

const NativeSelect = styled.select`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
`;

const IconContainer = styled.div`
  position: absolute;
  top: 1.6rem;
  right: 2rem;
  width: 1rem;
  height: 2.4rem;
  pointer-events: none;
  transform: rotate(0deg);
  transform-origin: 50% 50%;
  transition: transform 0.15s ease;
`;

const CustomSelect = styled.div`
  border: 1px solid;
  /* line-height: 2rem; */
  width: 100%;
  border-color: ${theme.color.black};
  background: transparent;
  color: ${theme.color.black};
  font-size: ${theme.font.size.default};
  transition: border-color 0.15s ease-in;
  padding: 1.4rem 1.4rem;
  padding-left: 2rem;

  ${NativeSelect}:focus + & {
    border-color:  rgba(96, 115, 139, 0.4);

    ${IconContainer} {
      transform: rotate(180deg);
    }
  }
`;

const InputLabel = styled.label`
  padding-bottom: 0.5rem;
  color: ${theme.color.black};
  font-size: ${theme.font.size.default};
`;

export const Select: FC<SelectProps> = ({
  label,
  value,
  onChange,
  iconId,
  children,
}) => {
  return (
    <>
      <InputLabel>{label}</InputLabel>
      <SelectGroup>
        <NativeSelect value={value} onChange={onChange}>
          {children}
        </NativeSelect>
        <CustomSelect>
          {value}
          <IconContainer>
            <Icon iconId={iconId} />
          </IconContainer>
        </CustomSelect>
      </SelectGroup>
    </>
  );
};
